import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

type SpinnerSize = 'sm' | 'md' | 'lg';

type SpinnerProps = {
  message?: string;
  size?: SpinnerSize;
  className?: string;
  compact?: boolean;
};

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'gap-3 py-8',
  md: 'gap-4 py-10',
  lg: 'gap-5 py-12',
};

const logoClasses: Record<SpinnerSize, string> = {
  sm: 'h-6',
  md: 'h-7',
  lg: 'h-8',
};

const indicatorClasses: Record<SpinnerSize, string> = {
  sm: 'h-5 w-5',
  md: 'h-6 w-6',
  lg: 'h-7 w-7',
};

const BrandedSpinner = ({
  message = 'Loading',
  size = 'md',
  className,
  compact = false,
}: SpinnerProps) => {
  const imagePath = process.env.PUBLIC_URL;

  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center px-4 text-center',
        compact ? 'gap-3 py-6' : sizeClasses[size],
        className
      )}
    >
      <div className="flex items-center justify-center gap-3">
        <img
          src={`${imagePath}/dhs-logo.svg`}
          alt="Los Angeles County Department of Health Services"
          className={cn('w-auto object-contain', logoClasses[size])}
        />
        <div className="h-7 w-px bg-[var(--neutral-gray-30)]" aria-hidden="true" />
        <img
          src={`${imagePath}/programs/logoDD.png`}
          alt="Office of Diversion and Reentry"
          className={cn('w-auto object-contain', logoClasses[size])}
          onError={(event) => {
            event.currentTarget.src = `${imagePath}/logoODR.png`;
          }}
        />
      </div>

      <div className="flex items-center justify-center gap-2 text-[var(--neutral-gray-90)]">
        <Loader2
          className={cn('animate-spin text-[var(--azure-primary)]', indicatorClasses[size])}
          aria-hidden="true"
        />
        <span className="text-sm font-medium">{message}</span>
      </div>
    </div>
  );
};

export const LoadingSpinner = (props: SpinnerProps) => <BrandedSpinner compact size="sm" {...props} />;

export const OdrLoadingSpinner = (props: SpinnerProps) => <BrandedSpinner size="md" {...props} />;
